import { styled } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { AiOutlinePlus } from "react-icons/ai";

import { Button } from "../../../../components/Form";

export const StyledButton = styled(Button)(() => ({
  minWidth: "max-content",
}));

export const PlusIcon = styled(AiOutlinePlus)(() => ({
  marginRight: "8px",
}));

const styles = makeStyles(() => ({
  productsGridWrapper: {
    padding: "16px 32px",
  },
  warehouseBadge: {
    display: "flex",
    marginLeft: "8%",
  },
  titleContainer: {
    backgroundColor: "#F8F9FC",
    height: "64px",
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    marginBottom: "24px",
    marginTop: "-15px",
    marginLeft: "-32px",
    width: "calc(100% + 64px)",
    padding: "0px 32px",
  },
  title: {
    fontFamile: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "24px",
    color: "#38CFC4",
  },
}));

export default styles;
